import { CSSProperties, useMemo, useState } from "react";
import { NavLink } from "react-router-dom";
import { styled, StyleObject } from "styletron-react";
import { ButtonTypes, CreateButtonStyle } from "../../Definitions";
import { CreateNavLinkStyle, NavLinkTypes } from "../../Definitions/navLinkTypes";
import { colors } from "../../Styles";

interface Button_Props_overrides {
  baseButton?: CSSProperties
  hoverStyles?: CSSProperties
  iconStyles?: CSSProperties
  hoverEnhancerStyles?: CSSProperties
  contentStyles?: CSSProperties
  subContentStyles?: CSSProperties
  hoverSubContentStyles?: CSSProperties
  childrenStyles?: CSSProperties
}

interface CoreNavLink_Props{
  content: string
  subContent?: string
  path: string
  endPath?: boolean
  icon?: JSX.Element | string
  navLinkType?: NavLinkTypes
  disabled?: boolean
  overrides?: Button_Props_overrides
}

export function CoreNavLink({ content, subContent, path, endPath = false, icon, navLinkType, disabled = false, overrides }: CoreNavLink_Props) {
  const { baseStyles, hoverStyles, iconStyles, contentStyles, childrenStyles, subContentStyles, hoverSubContentStyles, hoverIconStyles } = useMemo(() => CreateNavLinkStyle(navLinkType, overrides), [navLinkType, overrides]);
  const [isHovered, setIsHovered] = useState(false);

  // #region | Handle enhancers based on type
  const _iconFromType = (enhancer: JSX.Element | string | undefined, enhancerStyles: CSSProperties) => {
    if (!enhancer) return null;
    return typeof enhancer === "string" 
      ? <img alt="enhancer" src={enhancer} style={{ ...enhancerStyles, width: "40px" }} />
      : enhancer;
  }

  const iconFromType = _iconFromType(icon, iconStyles);
  // #endregion

  return (
    // <li style={{width: "fit-content", height: "fit-content"}}>
    <div style={{position: "relative", width: navLinkType === NavLinkTypes.systemNavLink ? "100%" : "fit-content", height: "fit-content"}}>
      <NavLink
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        to={path}
        end={endPath}
        style={({isActive}) => (
          (isActive||isHovered) ? {...baseStyles, ...hoverStyles} : {...baseStyles}
        )}
        children={({ isActive }) => (
          <div style={{ ...childrenStyles }}>
            { icon ? <div style={(isHovered || isActive) ? { ...iconStyles, ...hoverIconStyles} : { ...iconStyles } }> {iconFromType} </div> : <></>}
            <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
              <p style={{...contentStyles}}>{content}</p>
              {!subContent ? <></> : <p style={isHovered||isActive ? { ...subContentStyles, ...hoverSubContentStyles } : { ...subContentStyles }}>{subContent}</p>}
            </div>
          </div>
        )}
      />
      {disabled ? <div style={{position: "absolute", top: "0", left: "0", width: "100%", height: "100%", backgroundColor: colors.transparent, borderRadius: "10px"}}/> : <></>}
    </div>
    // </li>
  );
}


